import { Button } from "../BaseComponents";
import { colors, fonts } from "../../Styles";

type ButtonProps = {
  data: { id: number; name: string }[];  // Data kan være enten condition eller location data
  selectedItems: string[];  // De valgte items
 
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>;  // Setter for de valgte items
};

export default function GenericButton({data, selectedItems, setSelectedItems}:ButtonProps) {
  const toggleSelection = (name: string, setState: React.Dispatch<React.SetStateAction<string[]>>) => {
    setState((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };
  
  const uniqueIds = Array.from(new Set(data.map(item => item.id)));
  
  return (
    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
      {uniqueIds.map((id) => {
        const item = data.find((d) => d.id === id);
        if (!item) return null;

        const isActive = selectedItems.includes(item.name);

        return (
          <Button
            key={item.id}
            content={item.name}
            onClick={() => toggleSelection(item.name, setSelectedItems)}
            overrides={{
              baseButton: {
                width: "fit-content",
                height: "25px",
                backgroundColor: isActive ? colors.greyDarkSecondary : colors.transparent
              },
              hoverStyles: {
                backgroundColor: colors.greyDarkSecondary
              },
              contentStyles: {...fonts.paragraph}
            }}
          />
        );
      })}
    </div>
  );
}
